import * as React from 'react';
import styles from './index.less';
import { Space } from 'antd';
import FFormLayout from '@/components/FFormLayout';
import FComponentsLib from '@freelog/components-lib';
import FCoverImage from '@/components/FCoverImage';
import FCoverFooterButtons from '@/components/FCoverFooterButtons';
import * as AHooks from 'ahooks';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, DashboardPageModelState } from '@/models/connect';
import { OnMount_Page_Action, OnUnmount_Page_Action } from '@/models/dashboardPage';
import { FI18n, FUtil } from '@freelog/tools-lib';
import Sider from './Sider';
import Notice from './Notice';
import img_choiceLabel from '@/assets/choice-label@2x.png';
import FTooltip from '@/components/FTooltip';
import FPageFooter from '@/components/FPageFooter';
import { FTourMgr } from '@/utils/FTourMgr';
import FIcons from '@/components/FIcons';

interface DashboardProps {
  dispatch: Dispatch;
  dashboardPage: DashboardPageModelState;
}

function Dashboard({ dispatch, dashboardPage }: DashboardProps) {
  AHooks.useMount(() => {
    dispatch<OnMount_Page_Action>({
      type: 'dashboardPage/onMount_Page',
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_Page_Action>({
      type: 'dashboardPage/onUnmount_Page',
    });
  });

  AHooks.useMount(async () => {
    FTourMgr.init('dashboardPage', [
      {
        element: self.document.getElementById('header.createBtn'),
        title: FI18n.i18nNext.t('tours_dashboard_menu_create'),
        leftOffset: 10,
        rightOffset: 10,
      },
      {
        element: self.document.getElementById('dashboardPage.resource.data'),
        title: FI18n.i18nNext.t('tours_dashboard_section_resource_datas'),
      },
      {
        element: self.document.getElementById('dashboardPage.resource.release'),
        title: FI18n.i18nNext.t('tours_dashboard_section_resource_list'),
      },
      {
        element: self.document.getElementById('dashboardPage.node.data'),
        title: FI18n.i18nNext.t('tours_dashboard_section_node_datas'),
      },
      {
        element: self.document.getElementById('dashboardPage.node.release'),
        title: FI18n.i18nNext.t('tours_dashboard_section_node_list'),
      },
    ]);
  });

  return (
    <div className={styles.dashboard}>
      <Notice />

      {/*<div className={styles.title}>*/}
      {/*  <div style={{ height: 50 }} />*/}
      {/*  <div className={styles.title1}>*/}
      {/*    <span>萌新任务，完成即领20元现金奖励！</span>*/}
      {/*    <FPopover*/}
      {/*      placement='bottomRight'*/}
      {/*      content={<div>*/}
      {/*        <div style={{ display: 'flex' }}>*/}
      {/*          <i*/}
      {/*            style={{*/}
      {/*              width: 3,*/}
      {/*              height: 3,*/}
      {/*              borderRadius: '50%',*/}
      {/*              marginTop: 8,*/}
      {/*              marginRight: 5,*/}
      {/*              backgroundColor: '#666',*/}
      {/*              flexShrink: 0,*/}
      {/*            }}*/}
      {/*          />*/}
      {/*          <FComponentsLib.FContentText*/}
      {/*            text={'内测活动时间：' + FI18n.i18nNext.tAuto('event_newbie_eventperiod')}*/}
      {/*            type='normal'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*        <div style={{ height: 15 }} />*/}
      {/*        <div style={{ display: 'flex' }}>*/}
      {/*          <i*/}
      {/*            style={{*/}
      {/*              width: 3,*/}
      {/*              height: 3,*/}
      {/*              borderRadius: '50%',*/}
      {/*              marginTop: 8,*/}
      {/*              marginRight: 5,*/}
      {/*              backgroundColor: '#666',*/}
      {/*              flexShrink: 0,*/}
      {/*            }}*/}
      {/*          />*/}
      {/*          <FComponentsLib.FContentText*/}
      {/*            text={'分别完成下方的基础任务、资源任务和节点任务，即可领取对应的现金奖励。'}*/}
      {/*            type='normal'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*        <div style={{ height: 15 }} />*/}
      {/*        <div style={{ display: 'flex' }}>*/}
      {/*          <i*/}
      {/*            style={{*/}
      {/*              width: 3,*/}
      {/*              height: 3,*/}
      {/*              borderRadius: '50%',*/}
      {/*              marginTop: 8,*/}
      {/*              marginRight: 5,*/}
      {/*              backgroundColor: '#666',*/}
      {/*            }}*/}
      {/*          />*/}
      {/*          <FComponentsLib.FContentText*/}
      {/*            text={'完成【基础任务】中的【查看Freelog使用教程】【 Freelog社区签到】两个小任务，可额外各获得一个邀请名额'}*/}
      {/*            type='normal'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*        <div style={{ height: 15 }} />*/}
      {/*        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>*/}
      {/*          <i*/}
      {/*            style={{*/}
      {/*              width: 3,*/}
      {/*              height: 3,*/}
      {/*              borderRadius: '50%',*/}
      {/*              marginTop: 8,*/}
      {/*              // marginRight: 5,*/}
      {/*              backgroundColor: '#666',*/}
      {/*              flexShrink: 0,*/}
      {/*            }}*/}
      {/*          />*/}
      {/*          <FComponentsLib.FContentText*/}
      {/*            text={'可通过'}*/}
      {/*            type='normal'*/}
      {/*          />*/}
      {/*          <FComponentsLib.FTextBtn onClick={() => {*/}
      {/*            self.open(FUtil.Format.completeUrlByDomain('user') + FUtil.LinkTo.reward());*/}
      {/*          }}>【个人中心】—【活动奖励】</FComponentsLib.FTextBtn>*/}
      {/*          <FComponentsLib.FContentText*/}
      {/*            text={'，将内测期间获取的现金奖励提现至微信钱包。'}*/}
      {/*            type='normal'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*        <div style={{ height: 15 }} />*/}
      {/*        <div style={{ display: 'flex' }}>*/}
      {/*          <i*/}
      {/*            style={{*/}
      {/*              width: 3,*/}
      {/*              height: 3,*/}
      {/*              borderRadius: '50%',*/}
      {/*              marginTop: 8,*/}
      {/*              marginRight: 5,*/}
      {/*              backgroundColor: '#666',*/}
      {/*              flexShrink: 0,*/}
      {/*            }}*/}
      {/*          />*/}
      {/*          <FComponentsLib.FContentText*/}
      {/*            text={'活动的最终解释权归Freelog所有。'}*/}
      {/*            type='normal'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*      </div>}*/}
      {/*    ><span>*/}
      {/*      <FComponentsLib.FTextBtn>*/}
      {/*        <span style={{ display: 'inline-block', paddingLeft: 5 }}>活动说明</span>*/}
      {/*      </FComponentsLib.FTextBtn>*/}
      {/*    </span></FPopover>*/}

      {/*  </div>*/}
      {/*  <div style={{ height: 20 }} />*/}
      {/*  <div className={styles.title2}>*/}
      {/*    完成下列萌新任务，不仅可以快速了解“如何创建资源、如何通过Freelog对资源进行推广及变现”，还能领取20元现金奖励！<br />*/}
      {/*    完成全部任务仅需9分钟，快开始萌新之旅吧~*/}
      {/*  </div>*/}
      {/*  <div style={{ height: 30 }} />*/}
      {/*  <BoardCard />*/}
      {/*  <div style={{ height: 50 }} />*/}
      {/*</div>*/}

      <div style={{ height: 40 }} />
      <div className={styles.statistics}>
        <div className={styles.statisticsContent}>
          <div className={styles.statisticsLeft}>
            <FComponentsLib.FTitleText text={
              // '资源'
              FI18n.i18nNext.tAuto('dashboard_resource_title')
            } />
            <div style={{ height: 20 }} />
            <div className={styles.statisticsLeft_Panel}>
              <FFormLayout>
                <FFormLayout.FBlock title={
                  // '数据总览'
                  FI18n.i18nNext.t('dashboard_resource_subtitle1')
                }>
                  <div id={'dashboardPage.resource.data'}>
                    <div className={styles.statisticsLeft_Panel_Total}>
                      <span>{dashboardPage.resourceStatistic.totalProfit}</span>
                      <FComponentsLib.FContentText
                        text={
                          // 总收益（元）
                          FI18n.i18nNext.t('dashboard_resource_total')
                        }
                        type='normal'
                      />
                    </div>
                    <div style={{ height: 10 }} />
                    <Space size={20} className={styles.statisticsLeft_Panel_Week}>
                      <div className={styles.statisticsLeft_Panel_Week_Card}>
                        <span>
                          {
                            // 近30日收益（元）
                            FI18n.i18nNext.tAuto('dashboard_resource_revenue_lastXdays')
                          }
                        </span>
                        <div style={{ height: 10 }} />
                        <FComponentsLib.FTitleText
                          text={dashboardPage.resourceStatistic.lastWeekProfit}
                          type='h1'
                        />
                      </div>
                      <div className={styles.statisticsLeft_Panel_Week_Card}>
                        <span>
                          {
                            // 近30日签约量
                            FI18n.i18nNext.tAuto('dashboard_resource_signedcontracts_lastXdays')
                          }
                        </span>
                        <div style={{ height: 10 }} />
                        <FComponentsLib.FTitleText
                          text={dashboardPage.resourceStatistic.lastWeekContract}
                          type='h1'
                        />
                      </div>
                      {/*<div className={styles.statisticsLeft_Panel_Week_Card}>*/}
                      {/*  <span>近7日浏览量</span>*/}
                      {/*  <div style={{ height: 10 }} />*/}
                      {/*  <FTitleText text={'500'} type='h1' />*/}
                      {/*</div>*/}
                    </Space>
                  </div>
                </FFormLayout.FBlock>

                <FFormLayout.FBlock
                  title={
                    // '最近发布'
                    FI18n.i18nNext.t('dashboard_resource_subtitle2')
                  }
                  extra={
                    <Space size={25}>
                      <FComponentsLib.FTextBtn
                        onClick={() => {
                          self.open(FUtil.LinkTo.resourceCreatorEntry());
                        }}
                        type='default'
                      >
                        <FIcons.FAdd style={{ fontSize: 16 }} />
                        <span style={{ paddingLeft: 3, display: 'inline-block' }}>
                          {
                            // 新资源
                            FI18n.i18nNext.tAuto('dashboard_resource_btn_createresource')
                          }
                        </span>
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        onClick={() => {
                          self.open(FUtil.LinkTo.myResources());
                        }}
                        type='default'
                      >
                        <FIcons.FContent style={{ fontSize: 16 }} />
                        <span style={{ paddingLeft: 3, display: 'inline-block' }}>
                          {
                            // 查看全部
                            FI18n.i18nNext.tAuto('dashboard_resource_btn_viewmyresources')
                          }
                        </span>
                      </FComponentsLib.FTextBtn>
                    </Space>
                  }
                >
                  <div className={styles.releasedResources} id={'dashboardPage.resource.release'}>
                    {dashboardPage.latestResources.length > 0 &&
                      dashboardPage.latestResources.map((lr) => {
                        return (
                          <div key={lr.resourceID} className={styles.releasedResourceCard}>
                            <div className={styles.releasedResourceCard_Cover}>
                              <FCoverImage src={lr.cover} width={260} style={{ borderRadius: 4 }} />

                              {lr.isChoice && (
                                <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                                  <img
                                    src={img_choiceLabel}
                                    alt={''}
                                    style={{
                                      position: 'absolute',
                                      left: 10,
                                      top: 10,
                                      width: 24,
                                      height: 24,
                                    }}
                                  />
                                </FTooltip>
                              )}

                              <div className={styles.releasedResourceCard_Cover_Footer}>
                                <FCoverFooterButtons
                                  buttons={[
                                    {
                                      type: 'resourceDetails',
                                      fn() {
                                        self.open(lr.detailUrl);
                                      },
                                    },
                                    {
                                      type: 'edit',
                                      fn() {
                                        self.open(lr.editUrl);
                                      },
                                    },
                                    ...(lr.updateUrl === ''
                                      ? []
                                      : [
                                        {
                                          type: 'update' as 'update',
                                          fn() {
                                            self.open(lr.updateUrl);
                                          },
                                        },
                                      ]),
                                  ]}
                                />
                              </div>
                            </div>
                            <div style={{ height: 10 }} />
                            <FComponentsLib.FContentText
                              singleRow={true}
                              text={lr.resourceTitle || lr.resourceName.split('/')[1]}
                              type={'highlight'}
                              style={{ maxWidth: 260 }}
                            />
                            <div style={{ height: 5 }} />
                            <FComponentsLib.FContentText
                              type='additional2'
                              text={FUtil.Format.resourceTypeKeyArrToResourceType(lr.type)}
                              style={{ maxWidth: 260 }}
                              singleRow={true}
                            />
                            <div style={{ height: 5 }} />
                            <FComponentsLib.FContentText
                              singleRow
                              style={{ maxWidth: 260 }}
                              type='additional2'
                              text={
                                // 最近更新 {LatestUpdatedTime}
                                FI18n.i18nNext.tAuto('resource_card_label_lastupdated', {
                                  LatestUpdatedTime: lr.updateDate,
                                })}
                            />
                            <div style={{ height: 5 }} />
                            <div className={styles.policy}>
                              {lr.policies.length > 0 ? (
                                // ? resource.policy.map((i: string) => <Policy key={i} text={i} />)
                                <FComponentsLib.F_Contract_And_Policy_Labels
                                  data={lr.policies.map((p) => {
                                    return {
                                      text: p,
                                      dot: '',
                                    };
                                  })}
                                  singleRow
                                />
                              ) : (
                                <FComponentsLib.FContentText
                                  text={
                                    // 暂无授权策略
                                    FI18n.i18nNext.tAuto('resource_card_msg_noplans')
                                  }
                                  type='additional2'
                                />
                              )}
                            </div>
                            {/*<div style={{ height: 12 }} />*/}
                            {/*<div className={styles.user}>*/}
                            {/*  <img src={lr.useAvatar || img_choiceLabel} alt={''} />*/}
                            {/*  <span>{lr.username}</span>*/}
                            {/*</div>*/}
                          </div>
                        );
                      })}

                    {dashboardPage.latestResources.length === 0 && (
                      <div
                        style={{
                          height: 220,
                          display: 'flex',
                          width: '100%',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <FComponentsLib.FContentText text={'还未创建任何资源'} />
                        <div style={{ height: 20 }} />
                        <FComponentsLib.FRectBtn
                          onClick={() => {
                            self.open(FUtil.LinkTo.resourceCreator());
                          }}
                        >
                          {
                            // 新建资源
                            FI18n.i18nNext.tAuto('dashboard_resource_btn_createresource')
                          }
                        </FComponentsLib.FRectBtn>
                      </div>
                    )}
                  </div>
                </FFormLayout.FBlock>
              </FFormLayout>
            </div>

            <div style={{ height: 40 }} />
            <FComponentsLib.FTitleText text={
              // '节点'
              FI18n.i18nNext.tAuto('dashboard_node_title')
            } />
            <div style={{ height: 20 }} />
            <div className={styles.statisticsLeft_Panel}>
              <FFormLayout>
                <FFormLayout.FBlock title={
                  // '数据总览'
                  FI18n.i18nNext.t('dashboard_node_subtitle1')
                }>
                  <div id={'dashboardPage.node.data'}>
                    <div className={styles.statisticsLeft_Panel_Total}>
                      <span>{dashboardPage.nodeStatistic.totalProfit}</span>
                      <FComponentsLib.FContentText
                        text={
                          // 总收益（元）
                          FI18n.i18nNext.t('dashboard_node_total')
                        }
                        type='normal'
                      />
                    </div>
                    <div style={{ height: 10 }} />
                    <Space size={20} className={styles.statisticsLeft_Panel_Week}>
                      <div className={styles.statisticsLeft_Panel_Week_Card}>
                        <span>
                          {
                            // 近30日收益（元）
                            FI18n.i18nNext.tAuto('dashboard_node_revenue_lastXdays')}
                        </span>
                        <div style={{ height: 10 }} />
                        <FComponentsLib.FTitleText
                          text={dashboardPage.nodeStatistic.lastWeekProfit}
                          type='h1'
                        />
                      </div>
                      <div className={styles.statisticsLeft_Panel_Week_Card}>
                        <span>
                          {
                            // 近30日签约量
                            FI18n.i18nNext.tAuto('dashboard_node_signedcontracts_lastXdays')
                          }
                        </span>
                        <div style={{ height: 10 }} />
                        <FComponentsLib.FTitleText
                          text={dashboardPage.nodeStatistic.lastWeekContract}
                          type='h1'
                        />
                      </div>
                      {/*<div className={styles.statisticsLeft_Panel_Week_Card}>*/}
                      {/*  <span>近7日浏览量</span>*/}
                      {/*  <div style={{ height: 10 }} />*/}
                      {/*  <FTitleText text={'500'} type='h1' />*/}
                      {/*</div>*/}
                    </Space>
                  </div>
                </FFormLayout.FBlock>

                <FFormLayout.FBlock
                  title={
                    // '我的节点'
                    FI18n.i18nNext.t('dashboard_node_subtitle2')
                  }
                  extra={
                    <FComponentsLib.FTextBtn
                      type='default'
                      onClick={() => {
                        self.open(FUtil.LinkTo.nodeCreator());
                      }}
                    >
                      <FIcons.FAdd style={{ fontSize: 16 }} />
                      <span style={{ paddingLeft: 3, display: 'inline-block' }}>
                        {
                          // 新建节点
                          FI18n.i18nNext.tAuto('dashboard_node_btn_createnode')
                        }
                      </span>
                    </FComponentsLib.FTextBtn>
                  }
                >
                  <div className={styles.nodeList} id={'dashboardPage.node.release'}>
                    {dashboardPage.allNode.length > 0 &&
                      dashboardPage.allNode.map((an) => {
                        return (
                          <div key={an.nodeID} className={styles.node}>
                            <FComponentsLib.FContentText text={an.nodeName} type='highlight' />
                            <Space size={20}>
                              <FComponentsLib.FTextBtn
                                type='primary'
                                onClick={() => {
                                  self.open(an.displayUrl);
                                }}
                              >
                                {
                                  // 打开节点
                                  FI18n.i18nNext.tAuto('dashboard_node_btn_viewnode')
                                }
                              </FComponentsLib.FTextBtn>
                              <FComponentsLib.FTextBtn
                                type='primary'
                                onClick={() => {
                                  self.open(an.managingUrl);
                                }}
                              >
                                {
                                  // 管理节点
                                  FI18n.i18nNext.tAuto('dashboard_node_btn_managenode')
                                }
                              </FComponentsLib.FTextBtn>
                            </Space>
                          </div>
                        );
                      })}

                    {dashboardPage.allNode.length === 0 && (
                      <div
                        style={{
                          height: 220,
                          display: 'flex',
                          width: '100%',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <FComponentsLib.FContentText text={'还未创建任何节点'} />
                        <div style={{ height: 20 }} />
                        <FComponentsLib.FRectBtn
                          onClick={() => {
                            self.open(FUtil.LinkTo.nodeCreator());
                          }}
                        >
                          创建节点
                        </FComponentsLib.FRectBtn>
                      </div>
                    )}
                  </div>
                </FFormLayout.FBlock>
              </FFormLayout>
            </div>
          </div>

          <Sider />
        </div>
      </div>

      <div style={{ height: 100 }} />
      <FPageFooter />
    </div>
  );
}

export default connect(({ dashboardPage }: ConnectState) => ({
  dashboardPage,
}))(Dashboard);
